import { EuiSpacer } from '@elastic/eui';
import DangerBox from 'components/Web_User_Interface/720p_Series/Network/DDNS/DangerBox';
import DDNSTable from 'components/Web_User_Interface/720p_Series/Network/DDNS/ddnsTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  DangerBox,
  DDNSTable,
  BreadCrumbs,
  SEOHelmet,
  React
};